import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const MinimisePlayer: React.SFC<SVGIconProps> = ({ size = 10, isSquare, color = '#ffffff', ...props }) => (
  <BaseSvg width={size} height={isSquare ? size : size * (5 / 10)} viewBox="0 0 10 5" {...props}>
    <path fill={color} d="m0 0 5 5 5-5H0Z" />
  </BaseSvg>
);
